import React from "react";

export interface MenuCardDescriptionProps {
  title: string;
  text: string;
  children?: React.ReactNode;
}

const MenuCardDescription: React.FC<MenuCardDescriptionProps> = ({
  title,
  text,
  children,
}) => {
  return (
    <div className="menu-card-desc">
      <h2 className="menu-card-desc-title">{title}</h2>
      <div className="menu-card-desc-text">
        {text} {children}
      </div>
    </div>
  );
};

export default MenuCardDescription;
